module.exports = __webpack_public_path__ + "assets/img/activity-time-01441cf9.png";